export default __webpack_public_path__ + "static/media/all-games.ed490792.png";